import { ChangeDetectorRef, Component, ElementRef, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges, ViewChild, ViewEncapsulation } from "@angular/core";
import { DomSanitizer, SafeResourceUrl } from "@angular/platform-browser";
import { FileType } from "@bpm/models";
import { FileService, FileTypeService } from "@bpm/services";
import { Menu } from "@common/models";
import { AuthenticationService, AutoSaveLocalStorageService } from "@common/services";
import { InsightsService, MSTranslationService } from "@core/services";
import { environment } from "environments/environment";
import { getMimeType } from "@core/utils";
import { NgbDateStruct, NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { TranslateService } from "@ngx-translate/core";
import { DatatableComponent } from "@swimlane/ngx-datatable";
import { CustomSwalService } from "app/helpers";
import { FileItem, FileUploader } from "ng2-file-upload";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { FileViewerModalComponent } from "./file-viewer-modal/file-viewer-modal.component";
const URL = "url";

@Component({
    selector: 'app-file-manager-component',
    templateUrl: './file-manager.component.html',
    styleUrls: ['./file-manager.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class FileManagerComponent implements OnInit, OnDestroy, OnChanges {

    // Generals
    private _unsubscribeAll: Subject<any>;
    public isEnglish: boolean = false;
    public fileType: FileType;
    public readOnly: boolean = false;
    public fileTypeList: FileType[] = [];
    public fileTypeLoading: boolean = false;
    private THUMBS: string = "thumbs";
    private OTHER: string = "other";
    public multiFileTypeList: FileType[] = [];
    public multiFileType: FileType[] = [];
    public multipeFileTypeLoading: boolean = false;
    public multipleFileType: FileType[] = [];
    public dueDate: NgbDateStruct;
    public countriesMarketDistributors: any[] = [];
    public languages: any[] = [];
    public fileComment: string;
    public fileCommentEnglish: string;
    public urlTest: string | SafeResourceUrl;
    public tablePageSize: number = 10;
    public cardsPageSize: number = 9;
    public cardsPage : number = 1;
    public arrCards: any[];

    /**
    * Uploader initialization
    */
    public uploader: FileUploader = new FileUploader({
        url: URL,
        disableMultipart: true,
        isHTML5: true,
        autoUpload: false
    });


    // General Inputs
    @Input() typeProcess: string;
    @Input() menu: Menu;
    @Input() arrFile: any[] = [];
    @Input() isWizard: boolean;
    // Innovation
    @Input() filteredFileTypes: string[] = [];
    // Ingredient
    @Input() addDateField: boolean;
    @Input() isMultipleFileType: boolean;
    // Product
    @Input() showCountriesMarketDistributors: boolean;
    @Input() countriesMarketDistributorsList: any[] = [];
    @Input() showLanguagues: boolean;
    @Input() languagesList: any[] = [];
    @Input() showCommentField: boolean;
    // PDCA
    @Input() showsThumbsView: boolean = false;
    // Autosave
    @Input() hostHandleAutoSave: boolean = false;
    // Ingredient suppliers
    @Input() showSuppliersList: boolean = false;
    @Input() suppliersList: any[] = [];
    @Input() showEditButton: boolean = false;
    public fileSuppliers: any[] = [];

    // Row edit state
    public editingRow: any = null;
    public editingGroupKey: any = null;
    public editingFileTypes: any[] = [];
    public editingDueDate: NgbDateStruct | null = null;
    public editingSuppliers: any[] = [];

    // Outputs
    @Output() previousStep: EventEmitter<any[]> = new EventEmitter<any[]>();
    @Output() submit: EventEmitter<any[]> = new EventEmitter<any[]>();
    @Output() filesChanged: EventEmitter<any[]> = new EventEmitter<any[]>();

    // ViewChilds
    @ViewChild('fileInputRef') fileInput!: ElementRef;
    @ViewChild(DatatableComponent) fileTable: DatatableComponent; // Tabla archivos


    constructor(private _translateService: TranslateService,
        private _swalService: CustomSwalService,
        private _fileTypeService: FileTypeService,
        private _fileService: FileService,
        private _msTranslationService: MSTranslationService,
        private _sanitizer: DomSanitizer,
        private _cdr: ChangeDetectorRef,
        private _insightsService: InsightsService,
        private _authenticationService: AuthenticationService,
        private _modalService: NgbModal
    ) {

        // Handle unsubscribe
        this._unsubscribeAll = new Subject();

        // Adding file handling
        this.uploader.onAfterAddingFile = async (fileItem: FileItem): Promise<any> => {

            // Validation name lenght
            if (fileItem.file.name.length > 250) {
                // Display an error message or take appropriate action
                this._translateService.get(['PRODUCTS.DIALOGS.ERROR_MAX_LENGTH', 'COMMON.ACTIONS.OOPS']).pipe(takeUntil(this._unsubscribeAll)).subscribe(value => {
                    this._swalService.showWarningMsg(`${value['PRODUCTS.DIALOGS.ERROR_MAX_LENGTH']}`, `${value['COMMON.ACTIONS.OOPS']}`);
                });

                this.fileInput.nativeElement.value = '';

                return;
            }

            const property = this.isMultipleFileType ? 'fileTypes' : 'fileType';

            // Set multi file types
            let documentFileTypes = [];
            if (this.isMultipleFileType) {
                this.multiFileType.forEach(mft => {
                    documentFileTypes.push({
                        id: 0,
                        fileType: mft
                    });
                });
            }

            if (this.showCountriesMarketDistributors) {

                // Expand by country and language if multi selection found
                this.countriesMarketDistributors.forEach(cmd => {

                    const rowTable = {
                        documentName: fileItem.file.name,
                        documentUrl: undefined,
                        [property]: this.isMultipleFileType ? documentFileTypes : this.fileType,
                        ...(this.addDateField && { dueDate: new Date(this.dueDate.year, this.dueDate.month - 1, this.dueDate.day) }), // retrieve date if handle date files
                        country: this.isEnglish ? cmd.nameEnglish : cmd.name,
                        marketCountryId: cmd.id,
                        marketId: cmd.marketId,
                        marketCreatedAt: cmd.marketCreatedAt,
                        supplier: cmd.supplier,
                        comment: this.fileComment,
                        commentEnglish: this.fileCommentEnglish,
                        ...(this.showsThumbsView && { previewUrl: '../../../../../assets/images/repository/archivo.png'})
                    }

                    if (this.languages.length > 0) {
                        this.languages.forEach(l => {
                            this.arrFile.push({
                                ...rowTable,
                                language: l
                            });
                        });
                    } else {
                        this.arrFile.push({ ...rowTable });
                    }
                });

            } else {

                // Adding single row to table
                this.arrFile.push({
                    documentName: fileItem.file.name,
                    documentUrl: undefined,
                    [property]: this.isMultipleFileType ? documentFileTypes : this.fileType,
                    status: { code: "ACT" },
                    ...(this.addDateField && { dueDate: new Date(this.dueDate.year, this.dueDate.month - 1, this.dueDate.day) }),
                    ...(this.showCommentField && { comment: this.fileComment }),
                    ...(this.showCommentField && { commentEnglish: this.fileCommentEnglish }),
                    ...(this.showsThumbsView && { previewUrl: '../../../../../assets/images/repository/archivo.png'}),
                    ...(this.showSuppliersList && {
                        suppliers: [...this.fileSuppliers],
                        ...this.supplierGroupProps(this.fileSuppliers[0])
                    })
                });

            }


            this.arrFile = [...this.arrFile];
            this.computeDisplay();
            this.fileType = undefined;
            this.multiFileType = [];
            this.dueDate = null;
            this.countriesMarketDistributors = [];
            this.languages = [];
            this.fileComment = undefined;
            this.fileCommentEnglish = undefined;
            this.fileSuppliers = [];

            // Host autosave launchs inmediately upload to storage
            if(this.hostHandleAutoSave)
                await this.customUploadAll(true);

            // Emitir cambios en los archivos
            this.filesChanged.emit(this.arrFile);

            // updates cards view page
            if(this.showsThumbsView){
                this.setCardsPage(this.cardsPage);
            }

        };
    }


    /**
     * Handle input changes
     * @param changes 
     */
    ngOnChanges(changes: SimpleChanges): void {
        if (changes['filteredFileTypes']) {
            this.getFileTypeByMenu(this.menu);
        }

        if(changes['menu'] && this.menu)
            this.getFileTypeByMenu(this.menu);

        
        // Inicializar supplierGroupKey/supplierGroupName para agrupación
        if (changes['arrFile'] && this.arrFile) {
            this.arrFile.forEach(f => {
                if (f.supplierGroupKey === undefined) {
                    Object.assign(f, this.supplierGroupProps(f.suppliers?.[0]));
                }
            });
            this.computeDisplay();
        }

        // Detectar cambios en arrFile para recargar previews
        if (changes['arrFile']) {
            if (this.showsThumbsView && this.arrFile && this.arrFile.length > 0) {
                // Diferimos con Promise.resolve().then() para ejecutar preLoadThumbs
                // fuera del ciclo de CD actual y evitar NG0100.
                // setCardsPage (llamado desde preLoadThumbs) ya invoca detectChanges()
                // internamente, por lo que no es necesario llamarlo aquí.
                Promise.resolve().then(() => this.preLoadThumbs(this.arrFile));
            } else if (!this.arrFile || this.arrFile.length === 0) {
                // Si no hay archivos, limpiar las cards fuera del ciclo de CD actual
                Promise.resolve().then(() => {
                    this.arrCards = [];
                    this._cdr.detectChanges();
                });
            }
        }
    }


    /**
     * Init Component
     */
    async ngOnInit(): Promise<void> {

        // Setting language
        this.isEnglish = this._translateService.currentLang == "en";

        // Setting mode
        this.readOnly = this.typeProcess != "create" && this.typeProcess != "edit";

        // Load select
        this.getFileTypeByMenu(this.menu);

        this.computeDisplay();

        if (this.showsThumbsView)
            Promise.resolve().then(() => this.preLoadThumbs(this.arrFile));

    }


    /**
     * Sets preview and download urls from a file item
     * @param arr 
     */
    async preLoadThumbs(arr: any[]) {
        for (const fileItem of arr) {
            await this.getPreviewUrlFromBlob(fileItem);
        }

        this.setCardsPage(1);
    }


    /**
     * Gets preview and download URL from blob file
     * @param documentUrl 
     */
    async getPreviewUrlFromBlob(fileItem: any) {
        
        // Si no hay documentUrl, usar la imagen por defecto
        if (!fileItem.documentUrl) {
            fileItem.previewUrl = '../../../../../assets/images/repository/archivo.png';
            return;
        }
    
        const ext = fileItem.documentUrl.split('.').pop()?.toLowerCase();

        if (ext) {

            // Getting extension

            switch (ext) {
                case 'docx':
                case 'doc':
                    fileItem.previewUrl = '../../../../../assets/images/repository/word.png';
                    break;
                case 'xls':
                case 'xlsx':
                    fileItem.previewUrl = '../../../../../assets/images/repository/excel.png';
                    break;
                case 'ppt':
                    fileItem.previewUrl = '../../../../../assets/images/repository/powerpoint.png';
                    break;
                case 'jpg':
                case 'png':
                case 'jpeg':
                case 'bmp': {
                    // Creates preview url from blob
                    try {
                        let responseBlob = await this._fileService.downloadBlob(fileItem.documentUrl);
                        const blobFile = window.URL.createObjectURL(responseBlob);
                        fileItem.previewUrl = this._sanitizer.bypassSecurityTrustResourceUrl(blobFile);
                    } catch (error) {
                        this.log('Error al generar la vista previa de un archivo', { documentName: fileItem.documentName }, error, true);
                        fileItem.previewUrl = '../../../../../assets/images/repository/archivo.png';
                    }
                    break;
                }
                default:
                    fileItem.previewUrl = '../../../../../assets/images/repository/archivo.png';
            }

        } else {
            fileItem.previewUrl = '../../../../../assets/images/repository/archivo.png';
        }

    }


    setCardsPage(page: number): void {
        this.arrCards = this.arrFile.slice(this.cardsPageSize * (page - 1), this.cardsPageSize * page);
        this.cardsPage = page;
        this._cdr.detectChanges();
    }


    /**
     * Shown comment
     * @param comment 
     */
    showComment(comment: string) {
        this._swalService.showInformationMsg(comment);
    }



    /**
     * Updates language labels
     */
    updateSelectLabelLanguage() {

        this.isEnglish = this._translateService.currentLang == 'en' ? true : false;
        this.getFileTypeByMenu(this.menu);

        if(this.arrFile) {
            this.arrFile = [...this.arrFile];
            this.computeDisplay();
            // Emitir cambios en los archivos
            this.filesChanged.emit(this.arrFile);
        }
    }


    /**
     * recalculates tables width when change language
     */
    recalculateFilesTable() {
        this.fileTable.recalculate();
    }


    /**
     * Retrieves file type by his menu
     * @param menu 
     */
    getFileTypeByMenu(menu: Menu) {
        this.fileTypeLoading = true;
        this.multipeFileTypeLoading = true;

        this._fileTypeService.getByMenuId(menu?.id ?? 0).pipe(takeUntil(this._unsubscribeAll)).subscribe(
            response => {
                // Diferimos la asignación fuera del ciclo de CD actual para evitar NG0100.
                // ng-select v21 usa efectos internos que leen [items] durante CD;
                // si la respuesta HTTP llega mientras detectChanges() está activo (ej. desde
                // setCardsPage), Angular detecta el cambio de [] → [...] y lanza NG0100.
                Promise.resolve().then(() => {
                    if (this.filteredFileTypes.length > 0) {
                        this.fileTypeList = [];
                        this.filteredFileTypes.forEach(fft => {
                            if (response.some(r => r.name == fft))
                                this.fileTypeList.push(response.filter(r => r.name == fft)[0])
                        });

                    } else {
                        this.fileTypeList = [];
                        this.fileTypeList = response;
                    }

                    // Filling multiple filetype's list if required
                    if (this.isMultipleFileType)
                        this.multiFileTypeList = this.fileTypeList;

                    this.fileTypeLoading = false;
                    this.multipeFileTypeLoading = false;
                    this._cdr.detectChanges();
                });
            },
            error => {
                this.log('Error al cargar los tipos de archivo', {}, error, true);
                if (error) {
                    this._translateService.get(['COMMON.ERROR_INTECEPTOR.SELECT_NOTLOAD', 'BRAND.WIZARD.FILES.FILE_TYPE']).pipe(takeUntil(this._unsubscribeAll)).subscribe(value => {
                        this._swalService.showErrorMsg(`${value['COMMON.ERROR_INTECEPTOR.SELECT_NOTLOAD']} ${value['BRAND.WIZARD.FILES.FILE_TYPE']}`);
                    });
                }
            }
        )
    }


    /**
     * Uploads files to custom API
     * @returns 
     */
    async customUploadAll(showLoading: boolean) {

        if (this.uploader.queue.length <= 0)
            return;

        if (showLoading)
            this._swalService.showLoading();

        this.uploader.isUploading = true;
        let total = this.uploader.queue.length;
        let completed = 0;

        // Iterating queue
        for (const item of this.uploader.queue) {

            try {
                item.isUploading = true;

                let filesToUpload = this.arrFile.filter(f => f.documentName == item._file.name && f.documentUrl == undefined);
                let storageType = (!this.isMultipleFileType && filesToUpload[0]?.fileType.nameEnglish == "Design") ? this.THUMBS : this.OTHER; // When multi file only 'other' storage is available

                // upload to Blob storage
                const resp = await this._fileService.uploadBlob(item._file, storageType);

                // Defer documentUrl mutation to a new macrotask to avoid NG0100:
                // the HTTP callback resumes inside Zone.js during an active CD cycle,
                // so mutating a binding here causes ExpressionChangedAfterItHasBeenCheckedError.
                await new Promise<void>(resolve => setTimeout(() => {
                    filesToUpload.forEach(ftu => {
                        ftu.documentUrl = resp?.fileName;
                    });
                    this._cdr.detectChanges();
                    resolve();
                }, 0));

                item.isSuccess = true;
                item.isUploaded = true;
                item.isUploading = false;
                item.progress = 100;
                completed++;
                this.uploader.progress = Math.round((completed / total) * 100);

            } catch (error) {
                this.log('Error al subir un archivo', { documentName: item?._file?.name }, error, true);
                item.isSuccess = false;
                item.isUploaded = false;
                item.isUploading = false;

                if (showLoading)
                    this._swalService.showErrorMsg(error);
            }

        }

        this.uploader.isUploading = false;
        this.uploader.clearQueue();

        if (showLoading)
            this._swalService.close();

    }


    /**
     * Removes files 
     * @param row 
     */
    deleteFile(row: any) {
        const source = row._source || row;
        const isSupplierRemoval = row._source && source.suppliers?.length > 1;


        // Pregunta diferente según si elimina el archivo completo o solo quita un proveedor
        const confirmAction = isSupplierRemoval
            ? this._swalService.showQuestion(
                this._translateService.instant('COMMON.ACTIONS.WARNING_TITLE_MSJ'),
                this._translateService.instant('INGREDIENTS.WIZARD.FILES.REMOVE_SUPPLIER_FROM_FILE', { supplier: row.supplierGroupName, file: source.documentName }),
                this._translateService.instant('COMMON.BUTTONS.CONFIRM_DELETE'),
                this._translateService.instant('COMMON.BUTTONS.NO_KEEP')
              )
            : this._swalService.showDeleteQuestion(source.documentName);

        confirmAction.then(resp => {
            if (!resp?.isConfirmed) {
                this.log('Eliminación de archivo cancelada', { documentName: source.documentName });
                return;
            }

            if (resp && resp.isConfirmed) {
                this.log(isSupplierRemoval ? 'Quitó un proveedor de un archivo' : 'Eliminó un archivo', {
                    documentName: source.documentName,
                    supplier: isSupplierRemoval ? row.supplierGroupName : undefined,
                });

                // Si el archivo tiene más de un proveedor, solo elimina el proveedor de este grupo
                if (isSupplierRemoval) {
                    source.suppliers = source.suppliers.filter((s: any) => s.id !== row.supplierGroupKey);
                    Object.assign(source, this.supplierGroupProps(source.suppliers[0]));
                    this.arrFile = [...this.arrFile];
                    this.computeDisplay();
                    this.filesChanged.emit(this.arrFile);
                    this._cdr.detectChanges();
                    return;
                }

                // Busca si el archivo se encuentra dentro de la carga de archivos
                const fileItem = this.uploader.queue.filter((value) => value.file.name == source.documentName)[0];

                // Elimina el archivo dentro de la cola de carga de archivos
                if (fileItem)
                    this.uploader.queue.splice(this.uploader.getIndexOfItem(fileItem), 1);

                // Elimina el archivo dentro del array de archivos a cargar
                // Busca por referencia primero; fallback por propiedades para el caso de arrFileDisplay con _source
                let fileIndex = this.arrFile.indexOf(source);
                if (fileIndex === -1) {
                    fileIndex = this.arrFile.findIndex(f =>
                        f.documentUrl === source.documentUrl && f.documentName === source.documentName
                    );
                }
                if (fileIndex > -1) this.arrFile.splice(fileIndex, 1);

                // Si el archivo tiene id, significa que existe en la base de datos
                // if (row.id) {
                //     // Se cambia el valor del estado del archivo
                //     const delIndex = this.arrFile.findIndex((value) => value.documentName == row.documentName);

                //     let delFile = this.arrFile[delIndex];

                //     delFile.status.code = "ELI"
                // }
                this.arrFile = [...this.arrFile];
                this.computeDisplay();

                // Emitir cambios en los archivos
                this.filesChanged.emit(this.arrFile);

                // updates cards view page
                if(this.showsThumbsView)
                    this.setCardsPage(this.cardsPage);

            }
        });

    }


    /**
     * Abre el archivo en el visor (el mismo de belivpedia) dentro de un modal
     * @param row Archivo de la tabla o de la tarjeta
     */
    openFileViewer(row: any): void {
        const modalRef = this._modalService.open(FileViewerModalComponent, {
            centered: true,
            size: 'lg',
            windowClass: 'file-viewer-modal'
        });

        modalRef.componentInstance.file = {
            documentName: row.documentName,
            documentUrl: row.documentUrl,
            // Los diseños guardan una URL absoluta en vez del nombre en el storage
            isExternal: !this.isMultipleFileType && row.fileType?.nameEnglish == "Design"
        };
        modalRef.componentInstance.context = { menu: this.menu?.title ?? null, typeProcess: this.typeProcess ?? null };

        this.log('Abrió un archivo en el visor', { documentName: row.documentName });
    }


    /**
     * Handle files download
     * @param row 
     */
    async downloadFile(row: any) {

        let url;

        if (!this.isMultipleFileType && row.fileType.nameEnglish == "Design") {

            // Download from url 
            const respuestaBlob = await fetch(row.documentUrl);
            url = window.URL.createObjectURL(await respuestaBlob.blob());

        } else {

            //Download from blob
            let responseBlob = await this._fileService.downloadBlob(row.documentUrl)

            if (responseBlob) {
                url = window.URL.createObjectURL(responseBlob);
            }

        }

        const a = document.createElement('a');
        a.href = url;
        a.download = row.documentName;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        window.URL.revokeObjectURL(row.documentUrl);

    }


    /**
 * 
 * @param event 
 */
    async translateFileComment(event: any) {
        const translated = await this._msTranslationService.getTranslation(event.target.value);
        Promise.resolve().then(() => {
            this.fileCommentEnglish = translated;
            this._cdr.detectChanges();
        });
    }


    /**
     * Emit previous output
     */
    async back() {

        if (this.showCountriesMarketDistributors) {
            await this.customUploadAll(true);
        }

        this.previousStep.emit(this.arrFile);
    }


    /**
     * Upload pending files and emit submit output
     */
    async onSubmit() {

        await this.customUploadAll(true);
        this.submit.emit(this.arrFile);

    }


    /**
     * Genera supplierGroupKey y supplierGroupName a partir de un proveedor para agrupación en datatable
     */
    private supplierGroupProps(supplier: any): { supplierGroupKey: any, supplierGroupName: string } {
        return {
            supplierGroupKey: supplier?.id ?? null,
            supplierGroupName: supplier?.name ?? this._translateService.instant('INGREDIENTS.WIZARD.SUPPLIERS.VALIDATE_SUPPLIER')
        };
    }

    public arrFileDisplay: any[] = [];

    /**
     * Expande arrFile en arrFileDisplay agrupando por proveedor.
     * Un archivo con N proveedores genera N filas, una por grupo.
     * Cada fila tiene _source apuntando al objeto original en arrFile.
     */
    private computeDisplay(): void {
        if (!this.showSuppliersList) {
            this.arrFileDisplay = this.arrFile;
            return;
        }
        const result: any[] = [];
        this.arrFile.forEach(file => {
            const suppliers: any[] = file.suppliers || [];
            if (suppliers.length === 0) {
                result.push({ ...file, ...this.supplierGroupProps(null), _source: file });
            } else {
                suppliers.forEach(supplier => {
                    result.push({ ...file, ...this.supplierGroupProps(supplier), _source: file });
                });
            }
        });
        this.arrFileDisplay = result;
    }

    /**
     * Activa el modo edición inline para una fila de la tabla.
     * Carga los valores actuales del archivo en las propiedades de edición.
     * @param row Fila del datatable (puede ser un spread de arrFileDisplay con _source)
     */
    startEdit(row: any): void {
        const source = row._source || row;
        this.editingRow = source;
        this.editingGroupKey = row.supplierGroupKey ?? null;
        this.editingFileTypes = (source.fileTypes || []).map((ft: any) => ft.fileType);
        const d = source.dueDate ? new Date(source.dueDate) : null;
        this.editingDueDate = d ? { year: d.getFullYear(), month: d.getMonth() + 1, day: d.getDate() } : null;
        this.editingSuppliers = [...(source.suppliers || [])];
    }

    /**
     * Aplica los cambios de edición al archivo original y refresca la tabla.
     */
    saveEdit(): void {
        if (!this.editingRow) return;

        if (this.isMultipleFileType) {
            this.editingRow.fileTypes = this.editingFileTypes.map((ft: any) => ({ id: 0, fileType: ft }));
            this.editingRow.dueDate = this.editingDueDate
                ? new Date(this.editingDueDate.year, this.editingDueDate.month - 1, this.editingDueDate.day)
                : null;
        }
        if (this.showSuppliersList) {
            this.editingRow.suppliers = [...this.editingSuppliers];
            Object.assign(this.editingRow, this.supplierGroupProps(this.editingSuppliers[0]));
        }

        this.editingRow = null;
        this.editingGroupKey = null;
        this.arrFile = [...this.arrFile];
        this.computeDisplay();
        this.filesChanged.emit(this.arrFile);
        this._cdr.detectChanges();
    }

    /**
     * Cancela el modo edición inline sin guardar cambios.
     */
    cancelEdit(): void {
        this.editingRow = null;
        this.editingGroupKey = null;
    }


    /**
     * Handle unsubscribes event
     */
    ngOnDestroy(): void {
        // Unsubscribe from all subscriptions
        this._unsubscribeAll.next(null);
        this._unsubscribeAll.complete();
    }


    /**
     * Manda una traza a Application Insights, etiquetada con el proyecto y el
     * usuario que la originó. Como el componente es compartido, suma el menú
     * desde el que se usa.
     */
    private log(message: string, data: any, ex: any = null, error: boolean = false): void {
        const user = this._authenticationService.currentUserValue;
        const payload = { ...data, menu: this.menu?.title ?? null, typeProcess: this.typeProcess ?? null };

        if (error) {
            this._insightsService.traceError(environment.projects.FileManager, message, payload, ex, user);
            return;
        }

        this._insightsService.traceInfo(environment.projects.FileManager, message, payload, user);
    }
}
